import {
  ObservationLog,
  PaginatedListResponse,
  APIErrorResponse,
  SearchRequestParams,
} from '@/types'
import { UseQueryResult } from '@tanstack/react-query'
import { useQueryList } from './useQueryList'
import { QUERY_KEYS } from '@/constants'

export type UseObservationLogsSearchParams = SearchRequestParams & {
  id?: string
  date?: string
  createdBy?: string
  residence?: string
  behaviour?: string
  specie?: string
  observationType?: string
  project_leader?: string
  assigned_manager?: string
  hasProcessingComment?: boolean
  hasSoundRecordings?: boolean
  isApproved?: boolean
  isSoundRecordingsAnalysed?: boolean
  startDate?: string
  endDate?: string
  research_visit_event?: string
  place_type?: string
  task_status?: string
  analysis_status?: string
}

export const getUseObservationLogsKey = (): string[] =>
  QUERY_KEYS.OBSERVATION_LOGS.slice(0, 2) as string[]

export const useObservationLogs = (
  { ...params }: UseObservationLogsSearchParams,
  enabled = true
): UseQueryResult<PaginatedListResponse<ObservationLog>, APIErrorResponse> =>
  useQueryList({
    url: '/plannings/observation_logs/',
    options: {
      enabled,
    },
    params: {
      ...(!!params.id && { id: params.id }),
      ...(!!params.search && { search: params.search }),
      ...(!!params.createdBy && { created_by: params.createdBy }),
      ...(!!params.research_visit_event && {
        research_visit_event: params.research_visit_event,
      }),
      ...(params.residence !== undefined && {
        residence: params.residence,
      }),
      ...(!!params.behaviour && { behaviour: params.behaviour }),
      ...(!!params.specie && { specie: params.specie }),
      ...(!!params.observationType && {
        research_observation_log_type: params.observationType,
      }),
      ...(!!params.project_leader && { project_leader: params.project_leader }),
      ...(!!params.assigned_manager && {
        assigned_manager: params.assigned_manager,
      }),
      ...(params.hasProcessingComment !== undefined && {
        has_processing_comment: params.hasProcessingComment,
      }),
      ...(params.hasSoundRecordings !== undefined && {
        has_sound_recordings: params.hasSoundRecordings,
      }),
      ...(params.isApproved !== undefined && {
        is_approved: params.isApproved,
      }),
      ...(params.isSoundRecordingsAnalysed !== undefined && {
        is_sound_recordings_analysed: params.isSoundRecordingsAnalysed,
      }),
      ...(!!params.place_type && { place_type: params.place_type }),
      ...(!!params.task_status && { task_status: params.task_status }),
      ...(!!params.analysis_status && {
        analysis_status: params.analysis_status,
      }),
      ...(!!params.startDate && { date_start: params.startDate }),
      ...(!!params.endDate && { date_end: params.endDate }),
      limit: params.limit,
      offset: params.offset,
    },
  })
